import { ObjectValues } from "helpers/types";

export const ONE_PAGE_FOOTER_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;

export type IFooterVariant = ObjectValues<typeof ONE_PAGE_FOOTER_VARIANTS>;

export interface IFooterProps {
  variant?: IFooterVariant;
}
